import { render, staticRenderFns } from "./Minting.vue?vue&type=template&id=3b0cb5af&"
import script from "./Minting.vue?vue&type=script&lang=js&"
export * from "./Minting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports